interface JobEnums {
  ORDER_CONFIRM: string;
  PICKING_UP: string;
  PICKED_UP: string;
  DELIVERING: string;
  DELIVERED: string;
  ARRIVED_AT_DELIVERING: string;
  ARRIVED_AT_PICKUP: string;
  ITEM_DELIVERED: string;
  ITEM_LOADED: string;

  RETURN_TO_SENDER: string;
  PICKED_UP_FAILED: string;
  DELIVERY_FAILED: string;
  RETURN_FAILED: string;
}

const JobEnums = {
  ORDER_CONFIRM: "order_confirm",
  PICKING_UP: "picking_up",
  DELIVERING: "delivering",
  ARRIVED_AT_DELIVERING: "arrived_at_delivering",
  ARRIVED_AT_PICKUP: "arrived_at_pickup",
  ITEM_DELIVERED: "item_delivered",
  ITEM_LOADED: "item_loaded",
  COMPLETED: "completed",

  RETURN_TO_SENDER: "return_to_sender",
  RETURNED_SENDER: "returned_sender",
  RETURNED_TO_SENDER: "returned_to_sender",
  PICKED_UP_FAILED: "picked_up_failed",
  DELIVERY_FAILED: "delivery_failed",
  RETURN_FAILED: "return_failed",
  QUEUED: "queued",
  CANCELLED: "cancelled",

  NOT_ASSIGNED: "not_assigned",
  ASSIGNED: "assigned",
  ASSIGNING_COMPARTMENT: "assigning_compartment",

  DISPATCHING: "dispatching",
  ARRIVED_AT_DESTINATION: 'arrived_at_destination',

  SENDER_RETRIEVED: "sender_retrieved",
  CANCELLING: "cancelling",
  CANCEL_FAILED: "cancel_failed",
  PAUSED: "paused",
  EXPIRED: "expired",

  RETURN_TO_SENDER_FAILED: "return_to_sender_failed",

  IN_PROGRESS: "in_progress",
  SCHEDULED: "scheduled"
};

const getJobStatusLabel = (status: string) => {
  switch (status) {
    case JobEnums.ORDER_CONFIRM:
      return "Order Confirmed";
    case JobEnums.PICKING_UP:
      return "Picking Up";
    case JobEnums.PICKED_UP_FAILED:
      return "Pickup Failed";
    case JobEnums.DELIVERING:
      return "Delivering";
    case JobEnums.DELIVERY_FAILED:
      return "Delivery Failed";
    case JobEnums.ARRIVED_AT_DELIVERING:
      return "Arrived at Delivery";
    case JobEnums.ARRIVED_AT_PICKUP:
      return "Arrived at Pickup";
    case JobEnums.ITEM_DELIVERED:
      return "Item Delivered";
    case JobEnums.ITEM_LOADED:
      return "Item Loaded";
    case JobEnums.COMPLETED:
      return "Completed";
    case JobEnums.RETURN_TO_SENDER:
      return "Returning to Sender";
    case JobEnums.RETURNED_SENDER:
      return "Returned to Sender";
    case JobEnums.PICKED_UP_FAILED:
      return "Pickup Failed";
    case JobEnums.DELIVERY_FAILED:
      return "Delivery Failed";
    case JobEnums.RETURN_FAILED:
      return "Return Failed";
    case JobEnums.QUEUED:
      return "Queued";
    case JobEnums.CANCELLED:
      return "Cancelled";
    case JobEnums.NOT_ASSIGNED:
      return "Not Assigned";
    case JobEnums.ASSIGNED:
      return "Assigned";
    case JobEnums.ASSIGNING_COMPARTMENT:
      return "Assigning Compartment";
    case JobEnums.DISPATCHING:
      return "Dispatching";
    case JobEnums.ARRIVED_AT_DESTINATION:
      return "Arrived at Destination";
    case JobEnums.SENDER_RETRIEVED:
      return "Sender Retrieved";
    case JobEnums.CANCELLING:
      return "Cancelling";
    case JobEnums.CANCEL_FAILED:
      return "Cancel Failed";
    case JobEnums.PAUSED:
      return "Paused";
    case JobEnums.EXPIRED:
      return "Expired";
    case JobEnums.COMPLETED:
      return "Completed";
    case JobEnums.CANCELLED:
      return "Cancelled";
    case JobEnums.PAUSED:
      return "Paused";
    case JobEnums.EXPIRED:
      return "Expired";
    case JobEnums.QUEUED:
      return "Queued";
    case JobEnums.RETURN_TO_SENDER_FAILED:
      return "Return to Sender Failed";
    case JobEnums.RETURNED_TO_SENDER:
      return "Returned to Sender";
    case JobEnums.IN_PROGRESS:
      return "In Progress";
    default:
      return status.replaceAll('_', ' ').replace(/\b\w/g, char => char.toUpperCase());
  }
}

export { JobEnums, getJobStatusLabel };
